module.exports = __webpack_public_path__ + "static/media/5.18b9e1fa.jpg";